import { render, staticRenderFns } from "./customer_private_seas_detail.vue?vue&type=template&id=b5cdad26&"
import script from "./customer_private_seas_detail.vue?vue&type=script&lang=js&"
export * from "./customer_private_seas_detail.vue?vue&type=script&lang=js&"
import style0 from "./customer_private_seas_detail.vue?vue&type=style&index=0&id=b5cdad26&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports